import { render } from "./RegistroView.vue?vue&type=template&id=2afcf480"
import script from "./RegistroView.vue?vue&type=script&lang=js"
export * from "./RegistroView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\mnry7\\Documents\\front-saberes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__